import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const ServicesComponent = lazy(() => import('./services.tsx'));

export const servicesRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <ServicesComponent />
      </Suspense>
    )
  }
];
